import PlayArrowIcon from "@mui/icons-material/PlayArrowRounded";
import type { SxProps, Theme } from "@mui/material";
import { Box } from "@mui/material";
import useMergedSx from "@entrilia/shared/hooks/useMergedSx";
import type { InvestorCommunicationInfo } from "../../api/types/investorCommunicationsTypes";

interface Props {
  item: InvestorCommunicationInfo;
  sx?: SxProps<Theme>;
}

const coverImageSx: SxProps<Theme> = { display: "block", width: "100%", height: "100%", objectFit: "cover" };

const playBadgeSx: SxProps<Theme> = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 56,
  height: 56,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  bgcolor: "background.paper",
  borderRadius: "50%",
  boxShadow: 1,
  color: "primary.dark",
};

const NewsItemImage = ({ item, sx }: Props) => {
  const mergedSx = useMergedSx({ position: "relative", borderRadius: 1, overflow: "hidden" }, sx);

  if (item.type === "Video") {
    return (
      <Box sx={mergedSx}>
        {item.thumbnailUrl ? (
          <Box component="img" src={item.thumbnailUrl} alt="" sx={coverImageSx} />
        ) : (
          <Box sx={{ height: "100%", bgcolor: "background.grey" }} />
        )}
        <Box sx={playBadgeSx}>
          <PlayArrowIcon fontSize="large" />
        </Box>
      </Box>
    );
  }

  if (!item.heroImageUrl) {
    return null;
  }

  return (
    <Box sx={mergedSx}>
      <Box component="img" src={item.heroImageUrl} alt="" sx={coverImageSx} />
    </Box>
  );
};

export default NewsItemImage;
